export default __webpack_public_path__ + "static/media/agent-illustration.3b030966.svg";